/** True on macOS, where hotkeys are shown with ⌘ ⇧ ⌥ ⌃ symbols. */
export function isMacPlatform(nav: Pick<Navigator, "userAgent"> = navigator): boolean {
  return /Mac|iPhone|iPad/.test(nav.userAgent);
}
